import { styled } from '@mui/material';

export const StyledGradeBookWeekWrap = styled('div')(({ theme }) => ({
	display: 'grid',
	gridTemplateColumns: 'repeat(2, 1fr)',
	gap: '16px',

	[theme.breakpoints.down('lg')]: {
		gridTemplateColumns: '1fr',
	},

	[theme.breakpoints.down('sm')]: {
		gap: '8px',
	},
}));
